// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"ColorSelectorHome_cardsContainer__MgCvl","imageLink":"ColorSelectorHome_imageLink__1ezCm"};